import Image from 'components/shared/image';
import SiteLink from 'components/shared/sitelink/sitelink';
import useIsMobile from 'hooks/utils/useIsMobile';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useRouter } from 'next/router';
import styles from './readMoreArticles.module.scss';

const ReadMoreArticles = ({ data, locale }) => {
  const { title, articleHighlights, anchorId } = data;
  const isMobile = useIsMobile();
  const router = useRouter();

  const decideArticleImageStyle = image => {
    const imageType = isMobile ? image?.mobile : image?.desktop;

    if (imageType?.height <= 1000) return styles.articleHighlightImageSmall;
    if (imageType?.height <= 1200) return styles.articleHighlightImageMedium;
    if (imageType?.height > 1400) return styles.articleHighlightImageLarge;

    return styles.articleHighlightImageSmall;
  };

  return (
    <div id={anchorId} className={styles.articlesWrapper}>
      <h2 className={styles.readMoreTitle}>{title}</h2>
      <div className={styles.readMoreArticlesWrapper}>
        {articleHighlights.map(articleHighlight =>
          articleHighlight.articleLink?.slug ? (
            <SiteLink
              locale={locale}
              key={articleHighlight.articleLink?.slug}
              className={styles.articleCardWrapper}
              href={addLocaleToHref(articleHighlight.articleLink?.slug, locale, router)}
            >
              <div className={decideArticleImageStyle(articleHighlight.headlineImage.image)}>
                <Image
                  src={articleHighlight.headlineImage.image}
                  layout="fill"
                  loading="lazy"
                  sizes="(max-width: 899px) 33vw, 50vw"
                />
              </div>
              <div className={styles.articleInfo}>
                <h3 className={styles.articleCategory}>{articleHighlight.articleType}</h3>
                <h4 className={styles.articleTitle}>{articleHighlight.articleLink?.title}</h4>
              </div>
            </SiteLink>
          ) : null
        )}
      </div>
    </div>
  );
};

export default ReadMoreArticles;
